import UrlPattern from 'url-pattern';

export const createUrlPattern = (route: string) => {
  return new UrlPattern(route, {
    segmentValueCharset: 'a-zA-Z0-9-_~ % \\.\\#\\!\\@\\[\\]\\$\\+\\*',
  });
};
